import { Grid, Paper, Typography } from "@material-ui/core";
// Lib
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React from "react";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { version } from "../../../utils/setting";
import { styles } from "./styles";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
class BusinessReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getFormatDate = (date) => moment(date).format("DD/MM/YYYY");
  getValueDiscount = (order) => {
    if (order.discount.type === "percent")
      return order.discount.value * order.tempPrice;
    return order.discount.value;
  };
  getValueVoucher = (order) => {
    if (order.voucher.type === "percent")
      return order.voucher.discount * order.tempPrice;
    return order.voucher.discount;
  };
  deduplicate = (arr) => {
    let isExist = (arr, element) =>
      arr.find((x) => x.itemCode === element.itemCode);
    let result = [];

    arr.forEach((element) => {
      if (!isExist(result, element)) result.push(element);
    });
    return result;
  };
  countItem = (item) => {
    const { listOrders } = this.props;
    let listItem = [];
    listOrders.forEach((item) => {
      listItem = listItem.concat(item.item);
    });
    let count = 0;
    listItem.forEach((element) => {
      if (
        item.itemType !== "memberCard" &&
        item.itemCode === element.itemCode
      ) {
        count += element.quantity;
      } else if (item.itemCode === element.itemCode) {
        // Member Card không có quantity
        count++;
      }
    });
    return count;
  };
  countValue = (item) => {
    const { listOrders } = this.props;
    let listItem = [];
    listOrders.forEach((item) => {
      listItem = listItem.concat(item.item);
    });
    let count = 0;
    listItem.forEach((element) => {
      if (
        item.itemType !== "memberCard" &&
        item.itemCode === element.itemCode
      ) {
        count += element.quantity * element.itemPrice;
      } else if (item.itemCode === element.itemCode) {
        // Member Card không có quantity
        count += element.itemPrice;
      }
    });
    return count;
  };
  renderItemOrder = () => {
    const { classes, t, listOrders, setting, service } = this.props;
    let listItem = [];
    let subTotal = 0;
    listOrders.forEach((item) => {
      subTotal += item.tempPrice;
    });
    let total =
      service.usingTax === 1 ? subTotal + subTotal * setting.tax : subTotal;
    listOrders.forEach((item) => {
      listItem = listItem.concat(item.item);
    });
    listItem = this.deduplicate(listItem);
    listItem = listItem.filter((item) => item.itemCode);
    return (
      <React.Fragment>
        {listItem.map((item, index) => (
          <Grid key={index} container spacing={0}>
            <Grid item xs={12} sm={5} md={5}>
              <Typography
                className={classNames(
                  classes.textLeft,
                  classes.pl2,
                  classes.fs14
                )}
              >
                {item.itemName}:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={2} md={2}>
              <Typography
                className={classNames(classes.textCenter, classes.fs14)}
              >
                {this.countItem(item)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.pr2,
                  classes.fs14
                )}
              >
                <NumberFormat
                  suffix={` ${setting.currencyCode}`}
                  thousandSeparator={true}
                  displayType={"text"}
                  value={this.countValue(item)}
                />
              </Typography>
            </Grid>
          </Grid>
        ))}
        {/* <hr className={[classes.breakLineReport]}/> */}
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.textBold,
                classes.pl2,
                classes.fs14
              )}
            >
              {t("report_subtotal")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={subTotal}
              />
            </Typography>
          </Grid>
        </Grid>
        {service.usingTax === 1 && (
          <Grid container spacing={0}>
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                className={classNames(
                  classes.textLeft,
                  classes.textBold,
                  classes.pl2,
                  classes.fs14
                )}
              >
                {t("report_tax")}:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.pr2,
                  classes.fs14
                )}
              >
                <NumberFormat
                  suffix={` ${setting.currencyCode}`}
                  thousandSeparator={true}
                  displayType={"text"}
                  value={subTotal * setting.tax}
                />
              </Typography>
            </Grid>
          </Grid>
        )}
        <hr className={[classes.breakLineReport]} />
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.textBold,
                classes.pl2,
                classes.fs14
              )}
            >
              {t("report_total")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={total}
              />
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  renderStatistics = () => {
    const { classes, t, listBookings, totalBooking, listOrders } = this.props;
    const listBookingApp = listBookings.filter(
      (item) => item.createdBySpa === false
    );
    const listBookingNewClient = listBookings.filter(
      (item) => item.isFirstBooking === true
    );
    const listBookingMissed = listBookings.filter(
      (item) => item.status === "missed"
    );
    const listWalkIn = listOrders.filter((item) => {
      if (!item.booking) return false;
      return Object.keys(item.booking).length > 0;
    });

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2,
                classes.mt2
              )}
            >
              {t("report_total_booking")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.pr2,
                classes.mt2,
                classes.fs14
              )}
            >
              {totalBooking}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_total_booking_app")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              (
              {totalBooking === 0
                ? 0
                : Math.round(
                    (listBookingApp.length * 100) / totalBooking,
                    0.05
                  )}
              %) {listBookingApp.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_unique_client")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              (
              {totalBooking === 0
                ? 0
                : Math.round(
                    ((totalBooking - listBookingNewClient.length) * 100) /
                      totalBooking,
                    0.05
                  )}
              %) {totalBooking - listBookingNewClient.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_new_client")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              (
              {totalBooking === 0
                ? 0
                : Math.round(
                    (listBookingNewClient.length * 100) / totalBooking,
                    0.05
                  )}
              %) {listBookingNewClient.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_walk_in_client")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              {listWalkIn.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_client_not_checked_in")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              (
              {totalBooking === 0
                ? 0
                : Math.round(
                    (listBookingMissed.length * 100) / totalBooking,
                    0.05
                  )}
              %) {listBookingMissed.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_total_booking_success")}:{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              (
              {totalBooking === 0
                ? 0
                : Math.round(
                    ((totalBooking - listBookingMissed.length) * 100) /
                      totalBooking,
                    0.05
                  )}
              %) {totalBooking - listBookingMissed.length}
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  renderInvoice = () => {
    const { classes, t, listOrders, totalOrder, setting } = this.props;
    let valueDiscount = 0;
    const listAborted = listOrders.filter((item) => item.status === "abort");
    const listDiscount = listOrders.filter((item) => item.discount.value > 0);
    listDiscount.forEach((element) => {
      valueDiscount += this.getValueDiscount(element);
    });

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.pl2,
                classes.mt2,
                classes.textBold,
                classes.fs14
              )}
            >
              {t("report_invoice")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.pr2,
                classes.mt2,
                classes.textBold,
                classes.fs14
              )}
            >
              {totalOrder}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={8}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_aborted")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              {listAborted.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={5} md={5}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.pl2,
                classes.mt2,
                classes.textBold,
                classes.fs14
              )}
            >
              {t("report_discount")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} md={2}>
            <Typography
              className={classNames(
                classes.textCenter,
                classes.mt2,
                classes.textBold,
                classes.fs14
              )}
            >
              {listDiscount.length}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.pr2,
                classes.mt2,
                classes.textBold,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={valueDiscount}
              />
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  renderProfit = () => {
    const {
      classes,
      t,
      listOrders,
      totalOrder,
      setting,
      serviceCost,
    } = this.props;
    let valueOrders = 0;
    listOrders.forEach((element) => {
      valueOrders += element.totalPrice;
    });

    let salary = 0;
    if (serviceCost[0] && serviceCost[0].serviceCost) {
      let employeeSalary = serviceCost[0].serviceCost.find(
        (item) => item.name === "employee_salary"
      );
      salary = employeeSalary ? employeeSalary.value : 0;
    }
    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2,
                classes.mt2
              )}
            >
              {t("report_avg_sales")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.pr2,
                classes.mt2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(valueOrders / totalOrder)}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_gross_sales")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(valueOrders)}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_total_cost")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.fs14,
                classes.pr2
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(salary)}
              />
            </Typography>
          </Grid>
        </Grid>
        <hr className={[classes.breakLineReport]} />
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.textBold,
                classes.pl2,
                classes.fs14
              )}
            >
              {t("report_net_profit")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(valueOrders - salary)}
              />
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  renderPayment = () => {
    const { classes, t, listOrders, totalOrder, setting } = this.props;
    let valueVoucher = 0;
    let tempPrice = 0;
    const listVoucher = listOrders.filter((item) => {
      if (item.voucher) return Object.keys(item.voucher).length > 0;
      return false;
    });
    listVoucher.forEach((element) => {
      valueVoucher += this.getValueVoucher(element);
    });

    listOrders.forEach((element) => {
      tempPrice += element.tempPrice;
    });
    tempPrice -= valueVoucher;

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={4} md={4}></Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textCenter,
                classes.textBold,
                classes.mt3,
                classes.fs14
              )}
            >
              {t("report_count")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.mt3,
                classes.fs14
              )}
            >
              {t("report_amount")}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              {t("report_cash")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(classes.textCenter, classes.fs14)}
            >
              {totalOrder}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(tempPrice - valueVoucher)}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              Direct:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(classes.textCenter, classes.fs14)}
            >
              0
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={0}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              Visa/Master Card:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(classes.textCenter, classes.fs14)}
            >
              0
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={0}
              />
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={5} md={5}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.fs14,
                classes.pl2
              )}
            >
              Coupon:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} md={2}>
            <Typography
              className={classNames(classes.textCenter, classes.fs14)}
            >
              {listVoucher.length}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(valueVoucher)}
              />
            </Typography>
          </Grid>
        </Grid>
        <hr className={[classes.breakLineReport]} />
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textLeft,
                classes.textBold,
                classes.pl2,
                classes.fs14
              )}
            >
              {t("report_total")}:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography
              className={classNames(
                classes.textRight,
                classes.textBold,
                classes.pr2,
                classes.fs14
              )}
            >
              <NumberFormat
                suffix={` ${setting.currencyCode}`}
                thousandSeparator={true}
                displayType={"text"}
                value={Math.round(tempPrice)}
              />
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  render() {
    const { classes, t } = this.props;
    const { datetime } = this.props;
    let data = {
      from: new Date(moment(datetime).startOf("month").valueOf()),
      // to: new Date(moment(datetime, 'YYYYMM').add(moment(datetime, 'YYYYMM').daysInMonth() - 1, 'days')),
      to: new Date(moment(datetime).endOf("month").valueOf()),
    };
    return (
      <React.Fragment>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={12} className={classes.content}>
            <Paper className={classes.rootPortrait}>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textLeft]}>
                    {moment(new Date()).format("DD/MM/YYYY  h:mm A")}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textRight]}>
                    Masspa {version}
                  </Typography>
                </Grid>
              </Grid>
              <hr className={[classes.breakLineReport]} />
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    className={classNames(classes.title, classes.textCenter)}
                  >
                    {t("report_business_sumary_report")}
                  </Typography>
                  <Typography
                    className={classNames(classes.textCenter, classes.fs14)}
                  >
                    {t("report_report_for")}: {this.getFormatDate(data.from)} -{" "}
                    {this.getFormatDate(data.to)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    className={classNames(
                      classes.subTitle,
                      classes.backgroundPrimary
                    )}
                  >
                    {t("report_sale_break_down")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={6}>
                  <Grid
                    container
                    spacing={0}
                    className={classes.containerCountAmount}
                  >
                    <Grid item xs={12} sm={4} md={4}></Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <Typography
                        className={classNames(
                          classes.textCenter,
                          classes.textBold
                        )}
                      >
                        {t("report_count")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <Typography
                        className={classNames(
                          classes.textRight,
                          classes.textBold,
                          classes.pr2
                        )}
                      >
                        {t("report_amount")}
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.renderItemOrder()}
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography
                        className={classNames(
                          classes.subTitle,
                          classes.backgroundGray,
                          classes.mt4
                        )}
                      >
                        {t("report_appointment_statistics")}
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.renderStatistics()}
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography
                        className={classNames(
                          classes.subTitle,
                          classes.backgroundGray
                        )}
                      >
                        {t("report_invoice_detail")}
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.renderInvoice()}
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography
                        className={classNames(
                          classes.subTitle,
                          classes.backgroundGray,
                          classes.mt4
                        )}
                      >
                        {t("report_profit_reakdown")}
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.renderProfit()}
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography
                        className={classNames(
                          classes.subTitle,
                          classes.backgroundGray,
                          classes.mt4
                        )}
                      >
                        {t("report_payment_type_breakdown")}
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.renderPayment()}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({
  listBookings: state.report.listBookings,
  totalBooking: state.report.totalBooking,
  listOrders: state.report.listOrders,
  totalOrder: state.report.totalOrder,
  setting: state.setting.setting,
  service: state.service.service,
  serviceCost: state.serviceCost.serviceCost,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(BusinessReport)
  )
);
